import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DataTrackingService} from './data-tracking.service';
import {FormDataTrackingService} from './form-data-tracking.service';
import {FormUuidService} from './form-uuid.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
  ],
  providers: [
    DataTrackingService,
    FormDataTrackingService,
    FormUuidService,
  ],
})
export class DcpAdobeAnalyticsModule {
}
